<template>
    <div class="max_main_box" :style="'background-image: url(' + activity_background + ')'">
        <div class="line_space space10"></div>
        <div class="line_space space10"></div>
        <div class="line_space space10"></div>
        <div class="line_space space5"></div>
        <div class="info_box">
            <div class="line_space space2"></div>
            <div class="result_icon_box"><div class="icon icon_register_success"></div></div>
            <div class="line_space space2"></div>
            <div class="result_txt_box">确认成功</div>
            <div class="line_space space2"></div>
            <div class="result_tips_box">您已完成预约登记，祝您旅途愉快</div>
            <div class="line_space space4"></div>
        </div>
        <div class="line_space space2"></div>
        <div class="btn_line_box">
            <div class="btn cance" @click="routerToName('reserveIndex', {activity_id})">返回首页</div>
            <div class="btn confirm" @click="routerToName('reserveRecord', {activity_id})">查看预约</div>
        </div>
    </div>
</template>

<script>
    import mixins_reserve from '../../mixins/reserve'
    export default {
        name: "registerResult"
        ,mixins: [mixins_reserve]
        ,created: function() {
            this.getActivityBanner0();
        }
    }
</script>

<style lang="scss" scoped>
    .info_box{
        width: 6rem;
        border-radius: .2rem;
        box-shadow: $box_shadow_up;
        background-color: #fff;
        margin: 0 auto;

        .result_icon_box{

            .icon{
                width: 2rem;
                height: 2rem;
                margin: 0 auto;
            }
        }
        .result_txt_box{
            font-size: .48rem;
            font-weight: bold;
            text-align: center;
        }
        .result_tips_box{
            text-align: center;
            font-size: .3rem;
        }
    }

    .btn_line_box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .3rem;

        .btn{
            box-sizing: border-box;
            width: 3rem;
            line-height: .88rem;
            border-radius: .88rem;
            border: .02rem solid $color_bdr_green0;
            background-color: #fff;
            color: $color_green0;
            text-align: center;
            font-size: .3rem;

            &.cance{

            }
            &.confirm{
                background-color: $color_green0;
                color: #fff;
            }
        }
    }
</style>